// This file includes polyfills needed by Angular and is loaded before the app.
// You can add your own extra polyfills to this file.
import 'zone.js';
/** CSS Custom Property Support **/
// import cssVars from 'css-vars-ponyfill';

// cssVars({
//   onlyLegacy: true,
//   watch: true
// });
(window as any).global = window;
